module.exports = __webpack_public_path__ + "img/do.27ace193.svg";